import classnames from 'clsx';
import React from 'react';

import FormattedRelativeDate from '@swf/sports/components/FormattedRelativeDate/FormattedRelativeDate';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';

import type { EventStatusSize, TimeDisplayFormat } from '../../types';

import styles from './EventStatusTime.scss';

export interface Props {
  startTime: string;
  size: EventStatusSize;
  timeFormat?: TimeDisplayFormat;
}

const EventStatusTime = ({ startTime, size, timeFormat }: Props) => (
  <div
    className={classnames(styles.time, {
      [styles.timeXs]: size === 'XSmall',
      [styles.timeSm]: size === 'Small'
    })}
  >
    {timeFormat === 'LONG' ? (
      <SportsFormattedTimeZone date={startTime} format="medium" withTime />
    ) : timeFormat === 'RELATIVE' ? (
      <FormattedRelativeDate date={new Date(startTime)} showTime showDayName={false} />
    ) : (
      <SportsFormattedTimeZone date={startTime} withTime />
    )}
  </div>
);

export default EventStatusTime;
